import { render, staticRenderFns } from "./admin_parque.vue?vue&type=template&id=2b85ddde&scoped=true&"
import script from "./admin_parque.vue?vue&type=script&lang=js&"
export * from "./admin_parque.vue?vue&type=script&lang=js&"
import style0 from "./admin_parque.vue?vue&type=style&index=0&id=2b85ddde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85ddde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VDivider,VIcon,VList,VListTile,VListTileAction,VListTileContent})
